<template>
  <div class="map-container">
    <div class="map">
      <FieldMap ref="miniMap" :center="mapCenter" :zoom="mapZoom" mini>
        <LocationsLayer layer-id="locations" source-id="locations" />
        <ResourcesSelectedLayer
          layer-id="resources-selected"
          source-id="resources-selected"
          :show-resource="unit"
        />
      </FieldMap>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import { UnitNumber } from '@/models/unit_number'
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import LocationsLayer from '@/components/field-view-next/layers/LocationsLayer.vue'
import ResourcesSelectedLayer from '@/components/field-view-next/layers/ResourcesSelectedLayer.vue'

const props = withDefaults(
  defineProps<{
    unit: UnitNumber
    center?: { lat: number; lng: number } | null
  }>(),
  {
    center: null,
  },
)

const miniMap = ref()
const mapCenter = ref<
  | {
      lat: number
      lng: number
    }
  | undefined
>(undefined)
const store = useStore()
const mapCenterPoint = computed<
  | {
      latitude: number
      longitude: number
      zoom: number
    }
  | undefined
>(
  () =>
    (
      store.state as {
        organizationConfig: {
          mapCenterPoint?: {
            latitude: number
            longitude: number
            zoom: number
          }
        }
      }
    ).organizationConfig?.mapCenterPoint,
)

const mapZoom = computed(() => {
  if (props.center?.lat || props.center?.lng) {
    return 13
  }
  return mapCenterPoint.value?.zoom ?? 13
})
const setMapConfig = () => {
  mapCenter.value = {
    lat: props.center?.lat || mapCenterPoint.value?.latitude || 0,
    lng: props.center?.lng || mapCenterPoint.value?.longitude || 0,
  }

  if (miniMap.value) {
    miniMap.value.map?.jumpTo({
      center: mapCenter.value,
    })
  }
}

watch(
  () => props.unit,
  () => {
    setMapConfig()
  },
)
onMounted(() => {
  setMapConfig()
})
</script>

<style scoped>
.map-container {
  border-radius: var(--space-base);
  overflow: hidden;
}

.map {
  height: 320px;
}
</style>
